const normalizeBaseUrl = (value) => {
  if (!value) return "";
  return value.replace(/\/$/, "");
};

const isAbsoluteUrl = (value) => /^(?:https?:|data:|blob:)/i.test(value || "");

const PUBLIC_ASSET_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_S3_PUBLIC_BASE_URL);
const PUBLIC_ASSET_BUCKET = process.env.REACT_APP_S3_BUCKET;
const PUBLIC_ASSET_REGION = process.env.REACT_APP_AWS_REGION;

const getPublicAssetUrl = (key) => {
  if (key === undefined || key === null) return "";
  const rawKey = key.toString?.() || "";
  if (!rawKey) return "";
  if (isAbsoluteUrl(rawKey)) return rawKey;
  const trimmedKey = rawKey.startsWith("/") ? rawKey.slice(1) : rawKey;
  if (PUBLIC_ASSET_BASE_URL) return `${PUBLIC_ASSET_BASE_URL}/${trimmedKey}`;
  if (PUBLIC_ASSET_BUCKET && PUBLIC_ASSET_REGION) {
    return `https://${PUBLIC_ASSET_BUCKET}.s3.${PUBLIC_ASSET_REGION}.amazonaws.com/${trimmedKey}`;
  }
  return "";
};

const normalizeAssetKeys = (value) => {
  const raw = Array.isArray(value) ? value : value !== undefined && value !== null ? [value] : [];
  const cleaned = [];
  raw.forEach((entry) => {
    if (entry === undefined || entry === null) return;
    const candidate = entry?.key || entry?.url || entry;
    const text = candidate?.toString?.().trim?.() || "";
    if (text) cleaned.push(text);
  });
  return cleaned;
};

const resolveAssetUrl = (key, signedUrls = {}) => {
  if (!key) return "";
  const rawKey = key.toString?.() || "";
  if (!rawKey) return "";
  if (isAbsoluteUrl(rawKey)) return rawKey;
  return signedUrls?.[rawKey] || "";
};

export { getPublicAssetUrl, normalizeAssetKeys, isAbsoluteUrl, resolveAssetUrl };
